import React from 'react';

export default function LayoutWebpartContainer(props) {
  const { title = "", children, titleHide = false } = props;
  
    return (
    <div className="p-4">
      {!titleHide && <div className="text-xl font-semibold mb-[18px]">{title}</div>}
      {children}
    </div>
  );
}
